import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "VII. Occupation 職業", -1)
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-4" }
const _hoisted_4 = { class: "col-span-full lg:col-span-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-darkgray-800" }, "1. Job description/仕事内容", -1)
const _hoisted_6 = { class: "space-y-3 col-span-full lg:col-span-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-darkgray-800" }, "2. Work hours / 労働時間", -1)

import TextInput from '@/components/inputs/TextInput.vue';
import { numberonly } from '@/helpers/NumberHelper'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OccupationForm',
  props: {
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: true
    },
},
  setup(__props) {

const props = __props

const item = ref(props.form)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(TextInput, {
          modelValue: item.value.job_title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.job_title) = $event)),
          id: "job-title",
          type: "text",
          placeholder: "Job description/仕事内容",
          disabled: __props.disableInputs
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(TextInput, {
          id: "days_per_week",
          type: "text",
          placeholder: "Days per week / 週の勤務日数",
          disabled: __props.disableInputs,
          onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_unref(numberonly)())),
          modelValue: item.value.days_per_week,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.days_per_week) = $event))
        }, null, 8, ["disabled", "modelValue"]),
        _createVNode(TextInput, {
          modelValue: item.value.hours_per_day,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.hours_per_day) = $event)),
          id: "work-hours",
          type: "text",
          placeholder: "Hours per day / 1日の勤務時間",
          onKeypress: _cache[4] || (_cache[4] = ($event: any) => (_unref(numberonly)())),
          disabled: __props.disableInputs
        }, null, 8, ["modelValue", "disabled"])
      ])
    ])
  ]))
}
}

})